var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiCustomToolAutoScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7L19 10M19 10L16 13M19 10H13M4 7L1 10M1 10L4 13M1 10H7M7 16L10 19M10 19L13 16M10 19V13M13 4L10 1M10 1L7 4M10 1V7",
    fill: "var(--primaryA2)",
    stroke: "var(--primaryA1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiCustomToolAutoScale);
export default __webpack_public_path__ + "static/media/EICustomToolAutoScale.a7c6b731c2978e0c02e11fe08e645da6.svg";
export { ForwardRef as ReactComponent };